import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  InputNumber,
  message,
  Row,
  Space,
  Upload,
} from 'antd';
import React, { Component } from 'react';
import CountryApi from '../../functions/api/cms/CountryApi';
import TestimonialApi from '../../functions/api/cms/TestimonialApi';
import { CustomSelect } from '../booking/form/CustomSelect';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const { TextArea } = Input;

class FormTestimonial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEdit: false,
      testimonial: null,
      countries: [],
      selectedFile: null,
      img_local: null,
      image: null,
    };
  }

  formRef = React.createRef();

  componentDidMount = async () => {
    const { match } = this.props;

    if (match.params && match.path === '/testimonial/edit-testimonial/:id') {
      const { id } = match.params;
      const testimonial = await TestimonialApi.show(id);

      this.formRef.current.setFieldsValue({ name: testimonial.name });
      this.formRef.current.setFieldsValue({ age: testimonial.age });
      this.formRef.current.setFieldsValue({
        nationality: testimonial.nationality,
      });
      this.formRef.current.setFieldsValue({ comment: testimonial.comment });

      this.setState({
        isEdit: true,
        testimonial,
        image: testimonial.image_url,
      });
    }

    const countries = await CountryApi.index();
    this.setState({ countries });
  };

  fileChangedHandler = (info) => {
    if (info.file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ img_local: e.target.result, image: '' });
      };
      reader.readAsDataURL(info.file.originFileObj);
    }

    this.setState({
      selectedFile: info.file.originFileObj,
    });
  };

  submitForm = async (values) => {
    try {
      const { isEdit, testimonial, selectedFile } = this.state;
      if (null !== selectedFile) {
        values.image = selectedFile;
      }

      let result;

      if (isEdit) {
        result = await TestimonialApi.edit(testimonial.id, values);
      } else {
        result = await TestimonialApi.create(values);
      }

      if (null !== result) {
        message.success(`Đã lưu đánh giá`);
        this.props.history.push('/testimonial');
      } else {
        message.error('Đã có lỗi xảy ra, vui lòng thử lại');
      }
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { isEdit, testimonial, countries } = this.state;

    return (
      <>
        <h2>
          {isEdit
            ? `Sửa đánh giá của khách hàng ${testimonial.name}`
            : 'Thêm đánh giá'}
        </h2>
        <Form
          {...formItemLayout}
          className="bg-grey"
          onFinish={this.submitForm}
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['name']}
                label="Tên"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                name={['age']}
                label="Tuổi"
                rules={[{ required: true }]}
              >
                <InputNumber min={1} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['nationality']}
                label="Quốc tịch"
                rules={[{ required: true }]}
              >
                <CustomSelect
                  dataSource={countries}
                  labelField="short_name"
                  valueField="code"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={30}>
              <Form.Item
                name={['comment']}
                label="Đánh giá"
                rules={[{ required: true }]}
              >
                <TextArea />
              </Form.Item>
              <Form.Item name={['image']} label="Ảnh người dùng">
                <Upload name="file" onChange={this.fileChangedHandler}>
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
                <br />
                {(this.state.image || this.state.img_local) && (
                  <Image
                    style={{ height: 200, width: 'auto' }}
                    src={
                      this.state.image ? this.state.image : this.state.img_local
                    }
                    className="img-local"
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Space>
              <Button htmlType="submit" type="primary">
                Lưu
              </Button>
              <Button type="default" onClick={() => this.props.history.go(-1)}>
                Quay lại
              </Button>
            </Space>
          </Row>
        </Form>
      </>
    );
  }
}

export default FormTestimonial;
